export default __webpack_public_path__ + "static/media/Black Dragon Scale.d05df9e4.jpg";